import angular from 'angular';

(function () {
    'use strict';
    var core = angular.module('app.announcement');

    core.constant('ANNOUNCEMENT', Object.freeze({

        langs: ['de', 'en', 'es', 'fr', 'it', 'nl', 'pt'],

        allCategories: {
            "announcement.categories.news": "Actualité",
            "announcement.categories.tool_box": "Boîte à outils",
            "announcement.categories.document": "Document",
            "announcement.categories.event": "Evènement",
            "announcement.categories.incident": "Incident",
            "announcement.categories.maintaining": "Maintenance",
            "announcement.categories.new_product": "Nouveautés",
            "announcement.categories.regulation": "Réglementation",
            "announcement.categories.webinar": "Webinar"
        }
    }));

})();
